<template>
  <base-docs>
    <div class="docs">
    <h1 class="docs__title">{{ t(`docs.privacy.title`) }}</h1>
    <router-link :to="translations.i18nRoute({ name: 'home' })" class="docs__back">
      <img src="@icons/backArrow.svg" alt="arrow">
      <p class="docs__back-text">{{ t('continueShop') }}</p>
    </router-link>
    <div class="docs__block">
      <p class="docs__block-text">{{ t('docs.privacy.subtext1') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.subtext2') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.subtext3') }}</p>
    </div>
    <div class="docs__block">
      <p class="docs__block-title">{{ t(`docs.faq.title1`) }}</p>
      <p class="docs__block-subtitle">{{ t('docs.privacy.title1-1') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text1-1') }}</p>
      <p class="docs__block-subtitle">{{ t('docs.privacy.title1-2') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text1-2') }}</p>
      <p class="docs__block-subtitle">{{ t('docs.privacy.title1-3') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text1-3-1') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text1-3-2') }}</p>
    </div>
    <div class="docs__block">
      <p class="docs__block-title">{{ t(`docs.faq.title2`) }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text2') }}</p>
      <p class="docs__block-subtitle">{{ t('docs.privacy.title2') }}</p>
      <ul class="docs__block-ul">
        <li class="docs__block-text">{{ t('docs.privacy.text2-1') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-2') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-3') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-4') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-5') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-6') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-7') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-8') }}</li>
        <li class="docs__block-text">{{ t('docs.privacy.text2-9') }}</li>
      </ul>
    </div>
    <div class="docs__block">
      <p class="docs__block-title">{{ t(`docs.faq.title3`) }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text3-1') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text3-2') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text3-3') }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text3-4') }}</p>
    </div>
    <div class="docs__block">
      <p class="docs__block-title">{{ t(`docs.faq.title4`) }}</p>
      <p class="docs__block-text">{{ t('docs.privacy.text4-1') }}</p>
    </div>
    <div class="docs__block">
      <p class="docs__block-title">{{ t('docs.privacy.block-title5') }}</p>
      <i18n-t class="docs__block-text" tag="p" scope="global" keypath="docs.privacy.text5-1">
        <template #ppEmail>
          <a class="docs__block-link" :href="'mailto:' + companyEmail">{{ companyEmail }}</a>
        </template>
      </i18n-t>
    </div>
  </div>
  </base-docs>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";
import {useCompanyStore} from "@/stores/company.js";
import {computed} from "vue";
import BaseDocs from "@/components/base/base-docs.vue";

const {t} = useI18n()
const companyStore = useCompanyStore()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : ""
})
const companyEmail = computed(() => {
  return company.value?.emailFrom || '';
});
</script>

<style lang="scss" scoped>
.docs {
  &__title {
    font-family: Poppins, sans-serif;
    font-weight: 700;
    font-size: 32px;
    color: $black;
  }

  &__back {
    margin-left: -40px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &-text {
      color: #1e1e1e;
      font-family: Poppins, sans-serif;
      font-size: 32px;
      font-weight: 600;
    }
  }

  &__block {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    &-title {
      font-family: Poppins, sans-serif;
      font-size: 32px;
      font-weight: 600;
      color: #1e1e1e;
    }

    &-subtitle {
      font-family: Poppins, sans-serif;
      font-size: 22px;
      font-weight: 600;
      color: #1e1e1e;
    }

    &-text {
      font-family: Poppins, sans-serif;
      font-size: 18px;
      font-weight: 400;
      color: #1e1e1e;
    }

    &-ul {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    &-link {
      color: $main;

      @include hover {
        color: $mainHover;
      }
    }
  }
}
</style>